export default "/images/54dcc1ab0dd1994bb6e2877320723148.avif";